import { render, staticRenderFns } from "./Applet.vue?vue&type=template&id=014c8cd8&scoped=true"
import script from "./Applet.vue?vue&type=script&lang=js"
export * from "./Applet.vue?vue&type=script&lang=js"
import style0 from "./Applet.vue?vue&type=style&index=0&id=014c8cd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014c8cd8",
  null
  
)

export default component.exports